import $ from "jquery";
import A11yUtils from "@core/base/scripts/utils/a11y-utils";

export default class GlossaryTooltip {
  constructor(scrollHandler) {
    this.CLASSES = {
      show: "glossary-tooltip__popup--show"
    };
    this.scrollHandler = scrollHandler;
    this.hoverPopup = false;
    this.isVisible = false;
    this.$el = $('.glossary-tooltip');
    this.$currentBtn = null;
    this.container = null;
    this.popupElement = null;
    this.$tipFocusables = null;
    this.timeout=null;
  }

  init() {
    if (this.$el.length > 0) {
      this.container = this.$el.closest(".base-module");

      this.$el.on("focus", () => {
        this.cleanup();
      });

      this.$el.on("click mouseover", e => {
        e.preventDefault();
        this.show($(e.currentTarget));
      });
      this.$el.on("blur", e => {
        if (!this.$tipFocusables || !this.$tipFocusables.length) {
          this.cleanup();
        }
      });

      this.$el.on("keydown", e => {
        const key = e.which;
        if (A11yUtils.inputIsKeyboard() && (key === A11yUtils.keyboard.space || key === A11yUtils.keyboard.enter)) {
          e.preventDefault();
          this.show($(e.currentTarget));
        }
      });

      this.$el.on("mouseout", e => {
        e.preventDefault();
        this.timeout=setTimeout(() => {
          if (!this.hoverPopup) {
            this.hide();
          }
        }, 300);
      });
    }
  }

  show(el) {
    this.cleanup();
    //
    this.$currentBtn = el;
    this.popupElement = $(this.getTemplate());
    $("body").append(this.popupElement);
    //
    setTimeout(() => {
      this.setPosition();
      this.popupElement.addClass(this.CLASSES.show);
      /**
       * A11Y :
       * on show: focus on the first focusable of the tooltip element
       * on escape: hide tooltip element
       * on tab : trap focus in tooltip element
       */
      this.popupElement.on("mouseover", e => {
        this.hoverPopup = true;
        this.isVisible = true;
      });

      this.popupElement.on("mouseleave", e => {
        this.hoverPopup = false;
        this.hide();
      });

      this.popupElement.on("touchstart", function (e) {
        this.hoverPopup = true;
        this.isVisible = true;
        e.stopPropagation();
      });

      $("body").on("touchstart", e => {
        this.hoverPopup = false;
        this.hide();
      });

      this.$tipFocusables = this.popupElement.find(A11yUtils.FOCUSABLES);
      if (
        this.$tipFocusables &&
        this.$tipFocusables.length > 0 &&
        A11yUtils.inputIsKeyboard()
      ) {
        this.$tipFocusables[0].focus();
      }

      this.popupElement.on("keydown", evt => {
        const key = evt.which;
        if (key === A11yUtils.keyboard.esc && A11yUtils.inputIsKeyboard()) {
          this.hide();
          evt.preventDefault();
        }

        if (key === A11yUtils.keyboard.tab && A11yUtils.inputIsKeyboard()) {
          this.tab(evt);
        }
      });
      this.isVisible = true;

      //
    }, 0);
  }

  setPosition() {
    const w = $('.glossary-tooltip__popup__content').innerWidth();
    const h = $('.glossary-tooltip__popup__content').innerHeight();
    //
    const btnWidth = this.$currentBtn.width();
    const btnHeight = this.$currentBtn.height();
    const btnOffsetTop = this.$currentBtn.offset().top;
    const btnOffsetLeft = this.$currentBtn.offset().left;
    const btnTopPos = btnOffsetTop - this.scrollHandler.scrollTop;
    //
    const isBottom = btnTopPos + btnHeight + h < $(window).height();
    //
    let yPos = 0;
    if (isBottom) {
      yPos = btnTopPos;
    } else {
      yPos = btnTopPos - (h + this.$currentBtn.height());
    }

    let xPos = 0;
    //if true align the tooltip to the right
    if (btnOffsetLeft + w > $(window).width() && w - btnWidth < btnOffsetLeft) {
      xPos = btnOffsetLeft + btnWidth - w;
    }
    //if true align the tooltip to the left
    else if (
      btnOffsetLeft + w < $(window).width() &&
      w - btnWidth > btnOffsetLeft
    ) {
      xPos = btnOffsetLeft;
    }
    //else align the tooltip to the center
    else {
      xPos = btnOffsetLeft - (w - btnWidth) / 2;
    }
    //
    this.popupElement.toggleClass("glossary-tooltip__popup--top", !isBottom);
    this.popupElement.css({
      position: "fixed",
      top: yPos,
      left: xPos
    });
  }

  hide() {
    if (!this.isVisible) return;
    this.cleanup();
    if (A11yUtils.inputIsKeyboard()) {
      $(this.$currentBtn).focus();
    }
    this.isVisible = false;
  }

  tab(evt) {
    if (evt.shiftKey) {
      if (this.$tipFocusables && evt.target === this.$tipFocusables[0]) {
        evt.preventDefault();
        this.$tipFocusables[this.$tipFocusables.length - 1].focus();
      }
    } else if (
      this.$tipFocusables &&
      evt.target === this.$tipFocusables[this.$tipFocusables.length - 1]
    ) {
      evt.preventDefault();
      this.$tipFocusables[0].focus();
    }
  }

  cleanup() {
    if(this.timeout){
      clearTimeout(this.timeout);
    }
    if (this.popupElement) {
      this.popupElement.off();
      $("body").off("touchstart");
      this.popupElement.remove();
      this.popupElement = null;
    }
  }

  getTemplate() {
    const target = this.$currentBtn.data("target");
    const txt = this.container.find(`#${target}`).html();
    return `<div class="glossary-tooltip__popup" role="dialog" aria-labelledby="${this.$currentBtn.text()}">
      <div class="glossary-tooltip__popup__content">${txt}</div>
    </div>`;
  }
}
